import { Skeleton } from "@/shared/ui";
import TimesheetTableSkeleton from "./TimesheetTableSkeleton";

export default function TimesheetDetailSkeleton() {
  return (
    <div className="flex flex-col">
      <div className="flex items-center justify-between pt-1 pb-4 border-b surface-base-stroke mb-5">
        <div className="flex items-center gap-4">
          <Skeleton width={280} height={32} />
          <Skeleton width={120} height={24} borderRadius={12} />
        </div>
        <div className="flex items-center gap-2">
          <Skeleton width={40} height={40} borderRadius={8} />
          <Skeleton width={140} height={40} borderRadius={8} />
        </div>
      </div>

      <div className="flex flex-wrap justify-start items-center gap-2 mb-4 p-6 radius-3xl surface-base-fill">
        {Array.from({ length: 3 }).map(function renderTabSkeleton(_, i) {
          return <Skeleton key={i} width={[180, 200, 220][i]} height={40} borderRadius={8} />;
        })}
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-2 mb-4">
        {Array.from({ length: 4 }).map(function renderStatCardSkeleton(_, i) {
          return (
            <div key={i} className="surface-container-fill radius-3xl p-5 flex flex-col gap-3">
              <div className="flex items-center gap-2">
                <Skeleton width={32} height={32} borderRadius={6} />
                <Skeleton width={[120, 130, 100, 160][i]} height={16} />
              </div>
              <Skeleton width={60} height={32} />
            </div>
          );
        })}
      </div>

      <div className="p-7 surface-base-fill radius-3xl">
        <div className="mb-5">
          <Skeleton width={100} height={16} className="mb-3" />
          <div className="flex flex-wrap gap-2">
            {Array.from({ length: 9 }).map(function renderLegendSkeleton(_, i) {
              return <Skeleton key={i} width={[120, 140, 100, 110, 120, 100, 130, 90, 80][i]} height={32} borderRadius={6} />;
            })}
          </div>
        </div>

        <div className="mb-7">
          <Skeleton width={80} height={16} className="mb-3" />
          <div className="flex flex-wrap gap-5">
            {Array.from({ length: 4 }).map(function renderHolidaySkeleton(_, i) {
              return (
                <div key={i} className="flex items-center gap-2">
                  <Skeleton width={32} height={32} borderRadius={4} />
                  <Skeleton width={[160, 120, 120, 120][i]} height={14} />
                </div>
              );
            })}
          </div>
        </div>

        <TimesheetTableSkeleton />
      </div>
    </div>
  );
}
